var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconEditar({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 21C1.99986 19.7062 2.31352 18.4316 2.91408 17.2857C3.51464 16.1397 4.38419 15.1565 5.44815 14.4203C6.51212 13.6842 7.73876 13.217 9.02288 13.059C10.307 12.901 11.6103 13.0568 12.821 13.513M21.378 16.626C21.7764 16.2276 22.0001 15.6874 22.0001 15.124C22.0001 14.5606 21.7764 14.0204 21.378 13.622C20.9796 13.2236 20.4394 12.9999 19.876 12.9999C19.3126 12.9999 18.7724 13.2236 18.374 13.622L14.364 17.634C14.1262 17.8716 13.9522 18.1653 13.858 18.488L13.021 21.358C12.9959 21.444 12.9944 21.5353 13.0166 21.6221C13.0389 21.7089 13.0841 21.7882 13.1474 21.8516C13.2108 21.9149 13.2901 21.9601 13.3769 21.9824C13.4637 22.0046 13.555 22.0031 13.641 21.978L16.511 21.141C16.8337 21.0468 17.1274 20.8728 17.365 20.635L21.378 16.626ZM15 8C15 10.7614 12.7614 13 10 13C7.23858 13 5 10.7614 5 8C5 5.23858 7.23858 3 10 3C12.7614 3 15 5.23858 15 8Z",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEditar);
export default __webpack_public_path__ + "static/media/iconEditar.b1f2ff54b59d4943dfa7585c3483c466.svg";
export { ForwardRef as ReactComponent };